import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=23f7eeb8&scoped=true"
import script from "./ProjectNotes.vue?vue&type=script&lang=js"
export * from "./ProjectNotes.vue?vue&type=script&lang=js"
import style0 from "./ProjectNotes.vue?vue&type=style&index=0&id=23f7eeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f7eeb8",
  null
  
)

export default component.exports